import store from '../redux/store';
import { addNotif } from '../redux/NotificationSlice';

function sendNotification(severity, autoHideDuration, description) {
    store.dispatch(
        addNotif({
            severity: severity,
            autoHideDuration: autoHideDuration,
            description: description,
        })
    );
}

export default sendNotification;
